var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about container mb-4 mt-5"},[_c('section',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("What's this?")]),_c('div',{staticClass:"card-body"},[_vm._v("Have people over? Can't decide who gets to DJ? Let everybody be the DJ and vote on a playlist.")])])])
}]

export { render, staticRenderFns }